<template>
  <div class="col-md-12">
    <v-autocomplete
      v-if="!animalForConsultation.length"
      outlined
      placeholder="Pesquise a Matriz"
      item-value="id"
      item-text="name"
      return-object
      :items="computedAnimals"
      v-model="selectedMatrix"
      @update:search-input="searchAnimal"
      no-data-text="Nenhum resultado..."
      clearable
    ></v-autocomplete>

    
    <the-table 
      v-if="animalForConsultation.length"
      id="birth-consultation-table"
      :dataItems="animalForConsultation"
      :headers="headersForTable"
    >
      <template v-slot:actions="">
        <v-btn 
          class="primary success" 
          @click="
            animalForConsultation = [],
            computedAnimals = [],
            selectedMatrix = null
          "
        >Alterar</v-btn>
      </template>
    </the-table>
  </div>
</template>

<script>
import TheTable from "@/components/layout/TheTable.vue";
import {mapActions} from "vuex";
export default {
  name:"BirthFilters",
  data() {
    return {
      selectedMatrix:null,
      animalForConsultation:[],
      headersForTable:[
        {text:"Animal", value:"name"},
        {text:"Registro", value:"register"},
        {text:"Grau de Sangue", value:"degree_blood"},
        {text:"", value:"actions", has_slot:true, styles:"max-width:50px"},
      ],
      animalsList:[],
      alreadySearched:false
    }
  },
  components: {
    TheTable
  },
  computed: {
    computedAnimals: {
      get() {
        return this.animalsList.map(e => ({...e, name:e.code + " - " + e.name + " Registro: " + e.register}));
      },
      set(newVal) {
        this.animalsList = newVal;
      }
    }
  },
  methods: {
    ...mapActions("animals", [
      "actionSearchAnimalsGeneral",
      "actionGetAnimalsReasons"
    ]),
    ...mapActions("birth_consultation", [
      "actionGetAnimalsBirthsConsultation",
    ]),
    async searchAnimal(val) {
      if(val && val.length > 2 && !this.alreadySearched) {
        this.computedAnimals = await this.actionSearchAnimalsGeneral(val);
      }
    }
  },
  watch: {
    async selectedMatrix(val) {
      if(val) {
        this.alreadySearched = true;
        await this.actionGetAnimalsBirthsConsultation(val.id);
        this.animalForConsultation.push(val);
      } else {
        this.alreadySearched = false;
      }
    }
  },
  async mounted() {
    await this.actionGetAnimalsReasons();
  }
}
</script>